import { Button, Loader, PasswordInput } from "@mantine/core";
import { IconLock } from "@tabler/icons-react";
import { useRef } from "react";
import { type SubmitHandler, useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { usePostApi } from "src/hooks";
import { Notification } from "src/utils/Notification";

import { BackButton } from "../Forms.styled";

interface Props {
  newUser?: boolean;
}

interface IResetPasswordForm {
  password: string;
  repeatPassword: string;
}

const ResetPassword = ({ newUser }: Props) => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const { post, isLoading } = usePostApi();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<IResetPasswordForm>();

  const password = useRef({});
  password.current = watch("password", "");

  const onSubmit: SubmitHandler<IResetPasswordForm> = async data => {
    const code = searchParams.get("code");
    const email = searchParams.get("email");
    const userid = searchParams.get("userid");
    if (!code || !email) {
      Notification("Error", "Check that you are using the correct link", "red");
      return;
    }
    let params: any = { pw: data.password, code };
    if (userid) params = { ...params, userid };
    else params = { ...params, email };
    await post({
      request: "done-reset-password",
      body: { params },
      onSuccess: () => {
        Notification(
          "Succes",
          newUser
            ? "Password set successfully!"
            : "Password changed successfully!",
          "green",
        );
        handleBack();
      },
    });
  };

  const handleBack = () => {
    navigate("/login");
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <PasswordInput
        error={errors.password?.message}
        placeholder="New Password"
        leftSection={<IconLock size="1rem" />}
        withAsterisk
        {...register("password", {
          required: "⚠ This field is required",
          minLength: {
            value: 8,
            message: "⚠ Password must have at least 8 characters",
          },
        })}
      />
      <PasswordInput
        mt={10}
        error={errors.password?.message}
        placeholder="Re-Enter Password"
        leftSection={<IconLock size="1rem" />}
        withAsterisk
        {...register("repeatPassword", {
          required: "⚠ This field is required",
          validate: value =>
            value === password.current || "⚠ The passwords do not match",
        })}
      />
      <Button w="100%" mt={10} type="submit">
        {isLoading ? (
          <Loader color="#fff" mah={"20px"} />
        ) : newUser ? (
          "Submit"
        ) : (
          "Reset"
        )}
      </Button>
      <BackButton onClick={handleBack}>Back</BackButton>
    </form>
  );
};

export default ResetPassword;
